export const redirectToHomeRoutes = ["/sign_in", "/secure_login", "/sign_up"];

export const disableAuthRoutes: string[] = [];
